<template>
  <div class="form-container">
    <h1 class="form-title">{{ title }}</h1>
    <ul-form class="form-login" ref="loginFormPwd" :model="user" :rules="rules">
      <ul-form-item prop="loginName" label-width="0">
        <ul-input v-model="user.loginName" placeholder="用户名/手机/邮箱" :disabled="isSecurity"></ul-input>
      </ul-form-item>
      <ul-form-item prop="password" label-width="0" :error="errorMsg">
        <ul-input v-model="user.password" type="password" placeholder="密码" :disabled="isSecurity" @keydown.native.enter="login"></ul-input>
      </ul-form-item>
      <ul-form-item class="form-item-code" v-if="isSecurity" prop="code" :error="codeErrorMsg" label-width="0">
        <ul-input v-model="user.code" placeholder="请输入验证码"></ul-input>
        <ul-button class="btn-code" disabled v-if="remaining > 0 && remaining < 60">重新获取({{remaining}})</ul-button>
        <ul-button class="btn-code" v-else :disabled="user.cellphone == ''" @click="getPhoneCode">获取验证码</ul-button>
      </ul-form-item>
      <slot><ul-button class="btn-submit" type="primary" @click="login">登录</ul-button></slot>
    </ul-form>
  </div>
</template>
<script>
import User from '@/model/user.js'
import { device } from '@/utils/device.js'
import { getImgCode, checkSendsms } from '@/api/courseApi.js'
import { UMOOC_COOKIE_DOMAIN, WXPCLOGINAPPID, WXGZHAPPID } from '@/config'
import { mapGetters } from 'vuex'
export default {
  name: 'login',
  props: {
    title: {
      type: String,
      default: '登录'
    }
  },
  data () {
    return {
      user: new User(),
      mode: 1,  // 1账号登录 2手机号登录 3图形验证码
      isSecurity: false,  // 是否开启登录保护
      errorMsg: '',  //账号密码登录不成功提示
      codeErrorMsg: '', // 登录保护验证码不正确提示
      phoneErrorMsg: '',  //电话验证码登录不正确提示
      image: {
        code: '', //图形验证码
        url: '', // 图形验证码图片链接
        errorMsg: '',
        verKey: '' //图形验证码key
      },
      remaining: 60, //倒计时剩余时间
      rules: {
        loginName: [
          { required: true, message: '请输入用户名/手机号/邮箱', trigger: 'change' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'change' }
        ],
        code: [
          { required: true, message: '请输入动态验证码', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    ...mapGetters({'account': 'user/user'})
  },
  methods: {
    login () {
      this.errorMsg = ''
      this.$refs['loginFormPwd'].validate((valid, detail) => {
        if (valid) {
          if (this.isSecurity) {
           this.codeErrorMsg = ''
           this.user.checkcodeByLoginName()
            .then(data => {
               if (data.code == 1) {
                  if (data.result == -1) {
                    this.codeErrorMsg = '动态安全码已失效'
                  } else if (data.result == 0) {
                    this.codeErrorMsg = '动态安全码错误'
                  } else {
                    this.getLoginVersion()
                  }
                }
            })
          } else {
             // 登录保护
            this.user.getCheatInfo()
            .then((books) => {
              let cheatTips = ''
              if (books.length > 0) {
                cheatTips = books.map(item => `《${item.name}》`).join('、')
                return this.$message({
                  message: `系统检测到此账号在${cheatTips}课程学习中存在作弊等不当行为，系统已自动冻结此账号，请联系任课老师或平台进行处理`,
                  type: 'warning'
                })
              }
              this.checkLoginName()
            })
          }
          
        }
      });
    },
    getPhoneCode () {
      let errMsgs = []
      this.$refs['loginFormPhone'].validateField(['cellphone'], (err,detail) => {
        errMsgs.push(err)
      })
      if (errMsgs.every((item) => item === '')) {
        this.getImgCode()
      }
    },
    getImgCode () {
      getImgCode()
        .then(data => {
          this.mode = 3
          this.image.errorMsg = ''
          this.image.url = data.image
          this.image.verKey = data.verKey
        })
    },
    startTimer () {
      this.remaining = 59
      let timer = setInterval( () => {
        this.remaining--
        if (this.remaining == 0) {
          clearInterval(timer)
        }        
      }, 1000)
    },
    checkLoginName () {
      this.user.checkLoginName()
        .then((data) => {
          if (data.code == 1) {
            if (data.result == 3) {
              return this.errorMsg = '您已经连续输错5次，3分钟后重试'
            } else if (data.result == 1) {  // 校验通过
              this.getLoginVersion()
            } else if (data.result == 2) {
              //登录保护 验证码登录
             this.isSecurity = true
             this.startTimer()
            } else {
              this.errorMsg = '用户名/密码错误'
            }
          }
        })
    },
    getLoginVersion () {
      this.user.getLoginVersion()
      .then(result => {
        console.log(result)
        if(result.code == 1) {
          this.user.loginV1()
        } else if (result.code == 2) {
          this.user.loginV2()
        }
      })
      .catch(err => {
        console.log(err)
        if (err.code == 2) {
          this.user.loginV2()
        }
      })
    },
    checkInput(callback) {
      this.$refs['loginFormPwd'].validate((valid, detail) => {
        if (valid) {
          callback && callback(this.user)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .ul-page__body-content{
    background-color: inherit;
  }
}
.form-container{
  position: relative;
  width: 800px;
  margin: 0 auto;
  padding: 48px;
  background-color: $--color-white;
  border-radius: 4px;
  .form-title{
    margin: 0 0 32px;
    font-size: 30px;
    text-align: center;
    font-weight: normal;
  }
  .back {
    position: absolute;
    left: 20px;
    top: 20px;
    cursor: pointer;
    color: $--color-text-secondary;
    i{
      color: $--color-text-secondary;
      font-size: 14px;
    }
    &:hover{
      color: $--color-primary;
      i{
        color: $--color-primary;
      }
    }
  }
}
.form-login{
  width: 420px;
  margin: 0 auto;
  ::v-deep{
    .ul-input__inner{
      height: 44px;
      line-height: 44px;
    }
    .form-item-code{
      .ul-form-item__content{
        display: flex;
      }
      .ul-input{
        flex: 1;
        margin-right: 12px;
      }
    }
    .ul-input-group__prepend{
      background-color: $--color-white;
    }
  }
  .ul-button{
    padding: 14px 20px;
  }
  .btn-submit{
    margin-top: 18px;
    width: 100%;
  }
}
@media (max-width: 768px) {

  .form-container{
    position: initial;
    width: 100%;
    margin: 0;
    padding: 20px;
    .form-title{
      display: none;
    }
    .form-login{
      width: auto;
    }
  }
}
</style>